
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";
import { GuardTour, GuardTourType, GuardTourTypeOption } from "@/store/guard-tours/types";
import { FeaturesList } from "@/store/types";
import { Tag } from "@/types";
import { get } from "lodash";
import vSelect from "vue-select";
import vselect3 from "vselect3";
import api from "@/services/api.service";

const GuardTours = namespace("GuardTours");

@Component({
    components: {
        "v-select": vselect3
    }
})
export default class TourEditor extends Vue {
    @GuardTours.Action addNewGuardTour;
    @GuardTours.Action updateGuardTour;
    @GuardTours.State selectedAreaId: number;
    @GuardTours.Mutation mutateCurrentGuardTour: (guardTour: any) => void;
    @GuardTours.State filterTourTypeId: number;

    @Getter("getFeaturesList") featuresList: FeaturesList;

    public showTourModal: boolean = false;
    public tags: Tag[] = [];
    public selectedTags: Tag[] = []; 
    private editableTourTitle: string = "";
    private tourTypeSelected: number = GuardTourType.Guard;
    private guardTourType = GuardTourType;

    @Prop({default: null})
    public editableTour: GuardTour;

    @Emit("tour-updated")
    public emitTourUpdated(tour: GuardTour) {}

    private get isAssessmentTourEnabled(): boolean {
        return get(this.featuresList, ["Mobile", "AssessmentTours"], false);
    }

    public async mounted() {
        this.tags = await api.eventTags();        
    }

    public async saveTour(): Promise<void> {
        if (!this.editableTourTitle) {
            return;
        }

        if (this.editableTour) {
            var mutatedEditableTour = {
                title: this.editableTourTitle,
                guardTourTypeId: this.tourTypeSelected,
                tagIds: this.selectedTags.map(x => x.tagId),
            }

            this.mutateCurrentGuardTour(mutatedEditableTour);
            await this.updateGuardTour(this.editableTour);
            this.emitTourUpdated(this.editableTour);
        } else {
            var tourToAdd: GuardTour = {
                title: this.editableTourTitle,
                groupId: this.selectedAreaId,
                guardTourTypeId: this.tourTypeSelected,
                tagIds: this.selectedTags.map(x => x.tagId),    
                guardTourId: 0,
                guardTourSteps: []
            }

            var newTour = await this.addNewGuardTour(tourToAdd);
            this.emitTourUpdated(newTour);
        }

        this.showTourModal = false;
        this.editableTourTitle = "";        
    }

    public loadModal() {
        this.showTourModal = true;
        if (this.editableTour) {
            this.tourTypeSelected = this.editableTour.guardTourTypeId;
            this.editableTourTitle = this.editableTour.title;
            this.selectedTags = this.tags.filter(x => this.editableTour.tagIds.includes(x.tagId));
        } else {
            this.tourTypeSelected = this.filterTourTypeId;
            this.selectedTags = [];
        }
    }

    public get typeOptions() : GuardTourTypeOption[] {
        let map: GuardTourTypeOption[] = [];

        for(var tourType in GuardTourType) {
            if (typeof GuardTourType[tourType] === 'number') {
                map.push({label: tourType, id: parseInt(GuardTourType[tourType]) });
            }
        }

        return map;
    }

    public get tagOptions() {
        if (this.tags) {
            return this.tags.filter(t => t.feature === 'Mobile/AssessmentTours');
        }

        return [];
    }
}
